import useTracksStore, {
  TrackType,
  VOICE_TRACK_ID,
} from '@/shared/store/tracks.store.tsx'
import useMediaStore from '@/shared/store/media.store.tsx'
import { getAudioBufferFromAudioUrl } from '@/utils/get-audio-buffer-from-audio-url.ts'
import type {
  AudioFormClip,
  SpeechAsset,
} from '../../../../audio-form/data/dto/audio-form-input.ts'
import { mapAudioFormClipToClipPositions } from './map-audio-form-clip-to-clip-positions.ts'
import { speechSelector, useSpeechStore } from '@/shared/store/speech.store.ts'

export const mapSpeechesToClips = async (
  asset: SpeechAsset,
  clip: AudioFormClip
): Promise<void> => {
  // Load asset into media store
  const { addMedia } = useMediaStore.getState()
  if (!asset.uri) return

  // Load clip into tracks store
  const { addClip } = useTracksStore.getState()

  const speech = speechSelector(asset.speechId)(useSpeechStore.getState())
  // todo: this is a temporary hack. Ideally asset.id, but there's a bug in the audioform
  const mediaId = clip.assetRef

  // todo: store file name and use it as id
  addClip(VOICE_TRACK_ID, {
    id: crypto.randomUUID(),
    type: TrackType.Voices,
    trackId: VOICE_TRACK_ID,
    name: speech?.voice.id ?? '',
    mediaId,
    src: asset.uri,
    ...mapAudioFormClipToClipPositions(clip, asset.duration ?? 0), // todo: fix this
  })

  const audioBuffer = await getAudioBufferFromAudioUrl(asset.uri)
  addMedia(mediaId, audioBuffer)
}
